module.exports = __webpack_public_path__ + "img/page_3_2.4ee759db.png";